module.exports = __webpack_public_path__ + "img/实景点位.0b4b7322.svg";